<template>
  <div class="case">
    <div  v-if="isScrolled9">
      <Header/>
    </div>
    <!--    <div class="center" style="font-size: 2em;">-->
    <!--      <h2 style="margin-top: 80px">ZHL压缩技术行业应用</h2>-->
    <!--    </div>-->
    <div v-for="item in data" :key="index">

      <div class="center" style="margin-top: 120px;">
        <div class="between" style="width: 60%;margin: 5px;">
          <div style="width: 70%;text-align: left;font-size:larger;">
            <div style="font-size: 1.5em; margin: 15px;">{{ item.title }}</div>
            <div>
              <div v-html=item.content ></div>
<!--              {{item.content }}-->
            </div>


          </div>
          <div style="height: 100px;width:30%;"><img src="../assets/img/1-230109142523919.png"></div>

        </div>
      </div>
    </div>




    <div style="margin-top: 200px">
      <Footer/>
    </div>

  </div>
</template>
<script>
import Header from "@/views/header.vue";
import Banner from "../components/Banner";
import Footer from "@/views/footer.vue";
export default {
  components: {
    Header,
    Banner,
    Footer
  },
  data() {
    return {
      isScrolled9: true,
      storedValue:0,
      id:0,
      a:1111,
      data:[],
      title:"",
      description:"",
      title2:"",
      description2:"",
      title3:"",
      description3:"",
      loading: true,
      caseList: []
    };
  },
  created() {
    document.title = 'Yasubit|免费在线压缩图片视频软件下载-智慧林图片压缩网站';
  },
  mounted() {

    window.addEventListener('scroll', this.handleScroll9);
    console.log(sessionStorage.getItem('a'))
    this.id=sessionStorage.getItem('a');


    console.log("输出: 参数")
    console.log(this.id); // 输出: 'value'
    // 从 sessionStorage 获取数据
    // this.storedValue = sessionStorage.getItem('id');
    // console.log("输出: 'value'")
    // console.log(this.storedValue); // 输出: 'value'

    window.console.log("case");
    this.$http
        .get("Cases/GetCasesAll")
        .then(response => {
          //console.log(response);
          this.caseList = response.data;
          //window.console.log(this.caseList);
          this.loading = false;
        })
        .catch(function(error) {
          window.console.log(error);
        });
    this.getData()
  },
  methods:{
    handleScroll9() {
      // 获取当前滚动位置
      const scrollY = window.scrollY || window.pageYOffset;

      // 可以设置一个阈值来确定何时改变isScrolled9的值
      const dis = 100;

      // 判断滚动位置是否大于阈值
      if (scrollY > dis) {
        // 向下滚动，将isScrolled9设为false
        this.isScrolled9 = false;
      } else {
        // 向上滚动，将isScrolled9设为true
        this.isScrolled9 = true;
      }
      // const scrollDistance = window.scrollY || document.documentElement.scrollTop;
      // // 当滚动距离小于等于200px时，设置isScrolled9为true
      // this.isScrolled9 = scrollDistance <=500;

    },
    detail(){
// const a=this.a
      this.$router.push({
        name: 'text', // 使用路由的 name 属性
        params: { a: this.a }
      });

    },
    getData() {


      const headers = {};

      // 发送 GET 请求并在请求中添加自定义请求头
      this.$http.get(`yasubit/website/${this.id}`, { headers })
          .then(response => {
            // 请求成功时更新数据
            console.log(8888);
            this.data = response.data.data[0].archiveList;
            console.log( this.data)





          })
          .catch(error => {
            // 请求失败时处理错误
            console.error('Error fetching data:', error);
          });


    }


  }
};
</script>

<style lang="scss" scoped>


.between{

  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.center{
  display: flex;align-items: center; text-align: center;justify-content: center
}
.one-third{
  width: 33.333333%;
  height: 50px;
  background-color: pink;
}
.one-five{
  display: flex;align-items: center; text-align: center;justify-content: center;flex-direction: column;
  width: 20%;
  height: 50px;

}



.case {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  //background-color: #14679f;

  &-section {
    width: 100%;
    &-content {
      width: 1240px;
      min-height: 1000px;
      margin: 0 auto;
      background-color: #fff;

      &-list {
        width: 100%;
        height: 500px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid pink;

        img {
          width: 612px;
          height: 314px;
        }
        .content-list-abstract {
          width: 290px;
          height: 350px;
          padding: 0 20px;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          .abstract-title {
            line-height: 30px;
            font-size: 22px;
            color: #e13834;
          }
          .abstract-content {
            height: 150px;
            color: #484848;
            font-size: 15px;

            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 7;
            -webkit-box-orient: vertical;
            white-space: normal !important;
            word-wrap: break-word;
            //border: 1px solid pink;
          }
          .more {
            display: flex;
            justify-content: flex-start;
            .text-decoration {
              text-decoration: none;

              span {
                color: #000;
              }
              img {
                width: 12px;
                height: 12px;
              }
            }
          }
        }
        .abstract-active {
          order: -1;
        }
      }
    }
  }
}
</style>